import { render, staticRenderFns } from "./ProductWarrantyBanner.vue?vue&type=template&id=d1f6ff2a"
import script from "./ProductWarrantyBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductWarrantyBanner.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports